import { createFileRoute } from "@tanstack/react-router";
import { createSocialHeadMeta } from "~/lib/social-head";
import { COMMODITIES_SOCIAL_METADATA } from "~/lib/social-metadata";
import { createRwaMarketsRouteLoader } from "~/features/rwa-markets/rwa-markets-route-loader";

export const Route = createFileRoute("/_app/commodities")({
  head: () => ({
    meta: createSocialHeadMeta(COMMODITIES_SOCIAL_METADATA),
  }),
  loader: createRwaMarketsRouteLoader("commodities"),
});
